import styled from "styled-components";
import "./Navbar.css";
import StyledBurger from "./StyledBurger";

function Navbar() {
	return (
		<NavBar>
			<div className="logo">
				<h2>
					Portfolio<span>.</span>
				</h2>
			</div>
			<StyledBurger />
		</NavBar>
	);
}
const NavBar = styled.div`
	width: 100vw;
	height: 55px;
	display: flex;
	/* justify-content: center; */
	justify-content: space-between;
	background: #000;
	box-shadow: 0 8px 12px -2px rgba(185, 247, 252, 0.11);
	position: fixed;
	top: 0;
	z-index: 10;
	/* @media (max-width: 890px) {
		justify-content: flex-start;
		width: 300px;
		height: 100vh;
		flex-flow: column nowrap;
		top: 0;
		right: 0;
		transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
		transition: transform 0.3s ease-in-out;
		background: rgba(4, 26, 29, 0.8);
	} */
	.logo {
		color: white;
		padding: 10px;

		span {
			color: rgb(243, 0, 73);
			/* font-size: 1.2em; */
		}
	}
`;

export default Navbar;
